import { ABOUT_IMG } from "../lib/data";
import { CheckCircle2 } from "lucide-react";

const POINTS = [
  "Safety audits & statutory compliance",
  "Fire & electrical safety evaluations",
  "Risk assessments and engineering advisory",
  "Equipment testing & certification support",
];

export default function AboutSnippet() {
  return (
    <section data-testid="about-snippet" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 relative">
          <div className="relative aspect-[4/5] overflow-hidden rounded-2xl border border-navy/10 shadow-[0_24px_60px_rgba(15,61,110,0.18)]">
            <img src={ABOUT_IMG} alt="Safety inspector at industrial facility" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-navy/60 via-transparent to-transparent" />
          </div>
          <div className="absolute -bottom-6 -right-4 lg:-right-12 glass-card rounded-xl p-5 max-w-[260px]">
            <div className="font-heading text-3xl font-black text-navy">2018</div>
            <div className="text-sm text-slate-600 mt-1">Established as an ISO-certified safety consulting firm</div>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="kicker">Who We Are</div>
          <h2 className="mt-3 font-heading text-4xl sm:text-5xl font-black text-navy tracking-tight leading-tight">
            Built for industries that <span className="text-safety">cannot afford</span> safety failures.
          </h2>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed">
            Insafe Services Pvt. Ltd. is an ISO-certified safety consulting company established
            in 2018, helping organizations identify risks, improve compliance and create safer
            working environments through professional audits, assessments and engineering advisory.
          </p>
          <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-2 text-slate-700">
                <CheckCircle2 className="h-5 w-5 text-safety mt-0.5 flex-shrink-0" />
                <span>{p}</span>
              </li>
            ))}
          </ul>
          <a
            href="#services"
            data-testid="about-snippet-cta"
            className="inline-flex mt-10 items-center gap-2 text-navy font-medium border-b-2 border-safety pb-1 hover:gap-3 transition-all"
          >
            See our services →
          </a>
        </div>
      </div>
    </section>
  );
}
